import React from "react";
import DocumentVerification from "../components/DocumentVerification/DocumentVerification";

const DocumentVerificationScreen = () => <DocumentVerification />;

export default DocumentVerificationScreen;
